import React from 'react';
import { ArrowLeft, Zap } from 'lucide-react';

const BarberBadge = ({ nx, barberId, loading }) => {
  if (loading && !nx) {
    return <span className="barber-next barber-next-loading" data-testid={`barber-next-${barberId}`}>Checking availability&hellip;</span>;
  }
  if (nx?.kind === 'available') {
    return (
      <span className="barber-next barber-next-ok" data-testid={`barber-next-${barberId}`}>
        <Zap size={11} strokeWidth={2.5} style={{ verticalAlign: '-1px', marginRight: 3 }} />
        Next: {nx.label}
      </span>
    );
  }
  if (nx?.kind === 'fully_booked') {
    return <span className="barber-next barber-next-full" data-testid={`barber-next-${barberId}`}>Fully booked for 2 weeks</span>;
  }
  if (nx?.kind === 'no_hours') {
    return <span className="barber-next barber-next-nohours" data-testid={`barber-next-${barberId}`}>Working hours not set</span>;
  }
  return null;
};

export const BarbersStep = ({ barbers, barberNext, barberNextLoading, onSelect, onBack }) => (
  <div className="booking-step">
    <button className="back-btn" onClick={onBack}>
      <ArrowLeft size={16} /> Back
    </button>
    <h2>Choose your barber</h2>
    <div className="barber-list">
      {barbers.map((barber) => (
        <div
          key={barber.id}
          className="barber-card"
          onClick={() => onSelect(barber)}
        >
          <div className="barber-avatar">
            {barber.avatar_url ? (
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}/api/barbers/${barber.id}/avatar`}
                alt={barber.name}
                data-testid={`booking-barber-avatar-${barber.id}`}
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }}
              />
            ) : (
              barber.name.charAt(0)
            )}
          </div>
          <div className="barber-info">
            <h3>{barber.name}</h3>
            <p>{barber.role} · {barber.bio}</p>
            <BarberBadge nx={barberNext[barber.id]} barberId={barber.id} loading={barberNextLoading} />
          </div>
        </div>
      ))}
    </div>
  </div>
);
